import type { COLOR, LAYOUT } from 'vars/index'

import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import { PosterSC } from 'atoms/ImagePoster'
import { TextBoxSC } from 'atoms/TextBox'
import { BrandContainerSC } from 'blocks/BrandContainer'
import { DropdownLanguageSC } from 'blocks/Dropdown/Templates/DropdownLanguage.styled'
import { NavGroupMore } from 'blocks/NavGroup/NavGroup.styled'
import { FIXED_INDENTS, MEDIA } from 'vars/index'

export const NoticeTextSC = styled.div`
  display: flex;
  align-items: flex-end;
`

export const PromoTextSC = styled.div`
  display: flex;
  max-width: 348px;
  align-items: flex-start;

  ${MEDIA.MIN_1240} {
    max-width: 560px;
  }
  ${MEDIA.MIN_1640} {
    max-width: 764px;
  }
`

export const IconsGroupSC = styled.div`
  & ${IconSC} {
    cursor: pointer;
    height: 28px;
  }
`

export const SocialLinksSC = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_20});

  & ${TextBoxSC}, & ${IconsGroupSC} {
    display: flex;
    justify-content: flex-end;
    gap: var(${FIXED_INDENTS.INDENT_20});
  }
`

export const LinksBlockSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(${FIXED_INDENTS.INDENT_20});
`

export const FooterSC = styled.footer<{
  background: COLOR
  paddings?: Array<FIXED_INDENTS | LAYOUT>
}>`
  --desktop-logo-heigth: 40px;
  background: ${({ background }) => `var(${background})`};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  display: grid;
  margin-top: auto;
  width: 100%;
  grid-column-gap: var(${FIXED_INDENTS.INDENT_10});
  grid-row-gap: var(${FIXED_INDENTS.INDENT_40});
  grid-template-areas:
    'brand  link'
    'promo  promo'
    'languagePicker languagePicker'
    'social social'
    'notice notice';

  > a {
    width: fit-content;
  }
  & ${BrandContainerSC} {
    align-items: flex-start;
    grid-area: brand;

    & ${PosterSC} {
      max-width: 87px;
      ${MEDIA.MIN_600} {
        max-width: 144px;
      }
    }
  }

  ${DropdownLanguageSC} {
    grid-area: languagePicker;
  }

  & ${LinksBlockSC} {
    grid-area: link;

    & ${NavGroupMore} {
      display: none;
    }
  }

  & ${SocialLinksSC} {
    gap: var(${FIXED_INDENTS.INDENT_0});
    align-items: flex-start;
    grid-area: social;
  }

  & ${PromoTextSC} {
    grid-area: promo;
  }

  & ${NoticeTextSC} {
    grid-area: notice;
  }

  ${MEDIA.MIN_600} {
    grid-template-rows: auto auto;
    grid-template-areas:
      'brand  link'
      'promo  link'
      'languagePicker languagePicker'
      'notice social';

    & ${SocialLinksSC} {
      align-items: flex-end;
    }
  }

  ${MEDIA.MIN_1240} {
    grid-template-rows: var(--desktop-logo-heigth) auto;

    & ${BrandContainerSC} {
      height: var(--desktop-logo-heigth);

      & ${PosterSC} {
        max-width: 144px;
        max-height: var(--desktop-logo-heigth);
      }
    }
  }
`

export const FooterHeightAdjustSC = styled.div<{
  height?: number
}>`
  width: 100%;
  height: ${({ height }) => (height ? `${height}px` : `0px`)};
`
